"use client";

import { createContext, useContext, type ReactNode } from "react";

import type { DirectoryBadge } from "@/lib/directory-badges";

const DirectoryBadgesContext = createContext<DirectoryBadge[]>([]);

export function DirectoryBadgesProvider({
  badges,
  children,
}: {
  badges: DirectoryBadge[];
  children: ReactNode;
}) {
  return (
    <DirectoryBadgesContext.Provider value={badges}>
      {children}
    </DirectoryBadgesContext.Provider>
  );
}

export function useDirectoryBadges(): DirectoryBadge[] {
  return useContext(DirectoryBadgesContext);
}
